import { render, staticRenderFns } from "./selectTeamModal.vue?vue&type=template&id=1e4794dd&"
import script from "./selectTeamModal.vue?vue&type=script&lang=ts&"
export * from "./selectTeamModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports